import { useState } from 'react';
import { DisplayVariant, NumberInput } from '@hungryroot/pho';
import { Paragraph, Modal, Heading } from '@hungryroot/ramen';
import styles from './EditServingSizeStepperModal.module.css';

interface Options {
  label: string;
  value: string;
  pricePerServing: string;
  maxPricePerServing: string;
}

interface Props {
  initialValue?: number | string;
  isOpen: boolean;
  onDismiss: () => void;
  isLoading: boolean;
  onActionClick: (value: string) => void;
  heading: string;
  options: Options[];
}

const getPricePerServing = (quantity: string, options: Options[]) => {
  const priceOption = options.find((option: Options) => {
    return option !== null && String(option.value) === quantity;
  });

  return priceOption;
};

export function EditServingSizeStepperModal({
  initialValue = '',
  isOpen,
  onDismiss,
  isLoading,
  onActionClick,
  heading,
  options,
}: Props) {
  const [value, setValue] = useState<string>(initialValue.toString());

  const { pricePerServing, maxPricePerServing } =
    getPricePerServing(value, options) || {};

  const effectivePricePerServing =
    value === '0' && pricePerServing === undefined ? 0 : pricePerServing;

  return (
    <Modal
      showXButton
      onActionClick={() => {
        onActionClick(value);
      }}
      onDismiss={onDismiss}
      heading={heading}
      confirmButtonText="Save"
      ariaLabel={heading}
      isOpen={isOpen}
      isSubmitting={false}
      headingClassName={styles['modal-heading']}
      body={
        <>
          <NumberInput
            displayVariant={DisplayVariant.Oval}
            className={`${styles['row']} ${styles['servings']}`}
            isLoading={isLoading}
            label="Servings"
            value={Number(value)}
            minValue={0}
            maxValue={options.length}
            onChange={async (nextValue) => {
              setValue(nextValue.toString());
            }}
          />
          {effectivePricePerServing !== undefined && (
            <div className={styles.subtotal}>
              <Heading variant="H6">Subtotal</Heading>
              <Paragraph>
                {maxPricePerServing !== undefined &&
                  effectivePricePerServing !== 0 &&
                  effectivePricePerServing !== maxPricePerServing && (
                    <>
                      <span className={styles.strikethrough}>
                        {`$${maxPricePerServing}`}
                      </span>{' '}
                    </>
                  )}
                {`$${effectivePricePerServing}/serving`}
              </Paragraph>
            </div>
          )}
        </>
      }
    />
  );
}
